import {
  Card,
  Col,
  Divider,
  Flex,
  Form,
  Input,
  message,
  Space,
  Typography,
} from "antd";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Button from "../../Components/Atoms/DynamicButton";
import { openNotification } from "../../Components/Notification/Index";
import AuthService from "../../Services/auth.service";
import "./index.scss";
import { GoogleOutlined } from "@ant-design/icons";

const SignIn = () => {
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const authService = AuthService.getInstance();

  const id = searchParams.get("jdId");
  const redirect_url = searchParams.get("redirect_url")
    ? decodeURIComponent(searchParams.get("redirect_url") || "")
    : null;
  const handleSignUpClick = () => {
    if (id) {
      navigate(`/sign-up?jdId=${id}`);
    } else {
      navigate("/sign-up");
    }
  };

  const handleSignIn = async (formValues: any) => {
    try {
      setLoading(true);
      formValues.id = id;
      const response = await authService.signIn(formValues);
      if (response) {
        if (response.status === 500) {
          openNotification("error", "Account not exist with this mail", "");
          return;
        } else if (response.status === 401) {
          openNotification(
            "error",
            `${response?.data?.message}`,
            "Please check your credentials"
          );
          return;
        }

        if (response?.data?.access_token) {
          authService.setAccessTokenToLocalStorage(
            response?.data?.access_token
          );
          if (id) {
            navigate(`/${id}/requirements`);
          } else if (redirect_url) {
            const normalizedRedirectUrl = redirect_url.startsWith("/")
              ? redirect_url
              : `/${redirect_url}`;
            navigate(normalizedRedirectUrl);
          } else {
            navigate("/");
            openNotification("success", "Sign in success", "");
          }
        } else {
          console.error("Invalid response from server");
        }
      }
    } catch (err) {
      console.error("Error while signing in user:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleAuthClick = async () => {
    try {
      const domain = window.location.hostname;
      await authService.handleGoogleAuth(domain);
    } catch (error) {
      console.error("Error while signing up user:", error);
      message.error("Error while signing up user. Try again!");
    }
  };

  const handleLinkedinAuthClick = async () => {
    try {
      const domain = window.location.hostname;
      await authService.handleLinkedinAuth(domain);
    } catch (error) {
      console.error("Error while signing up user:", error);
      message.error("Error while signing up user. Try again!");
    }
  };

  const handleForgottenPasswordClick = () => {
    navigate("/forgot-password");
  };

  return (
    <div className="signin-container">
      <div className="signin-content">
        <Card
          className="signin-card"
          style={{ maxWidth: 360, width: "100%" }}
          bordered
          title={
            <Divider orientation="left">
              <Typography.Title level={4} style={{ margin: 0 }}>
                Sign in
              </Typography.Title>
            </Divider>
          }
        >
          <Form
            name="normal_login"
            className="login-form"
            initialValues={{ remember: true }}
            onFinish={handleSignIn}
            autoComplete="off"
          >
            <Form.Item
              name="email"
              rules={[
                {
                  required: true,
                  pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: "Please enter a valid email address!",
                },
              ]}
            >
              <Input placeholder="Email" />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please enter your password!",
                },
              ]}
            >
              <Input.Password placeholder="Password" />
            </Form.Item>

            <Form.Item>
              <Space size={16} direction="vertical" style={{ width: "100%" }}>
                <Flex align="center" justify="end">
                  <Button
                    onClick={handleForgottenPasswordClick}
                    type="link"
                    style={{ marginBottom: 8, padding: 0 }}
                  >
                    Forgot password?
                  </Button>
                </Flex>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  loading={isLoading}
                >
                  {isLoading ? "" : "Sign In"}
                </Button>
                <Flex gap={10} vertical={true}>
                  <Button
                    icon={
                      <img
                        src="/assets/google.svg"
                        alt="Google"
                        style={{ width: 20 }}
                      />
                    }
                    onClick={handleGoogleAuthClick}
                    style={{ width: "100%" }}
                  >
                    Sign in with Google
                  </Button>
                  <Button
                    icon={
                      <img
                        src="/assets/linkedin.svg"
                        alt="Google"
                        style={{ width: 20 }}
                      />
                    }
                    style={{ width: "100%" }}
                  >
                    Sign in with LinkedIn
                  </Button>
                </Flex>
                <Typography.Paragraph style={{ textAlign: "center" }}>
                  Don't have an account?{" "}
                  <Button onClick={handleSignUpClick} type="link">
                    Create an account
                  </Button>
                </Typography.Paragraph>
              </Space>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default SignIn;
